import React, { useState, useEffect } from 'react'
import { ButtonDiv } from './ButtonStyled'
import { buttonProps } from './interfaces'
import isMobileDevice from '../../functions/checkers/isDeviceMobile'

export default function Button({
  children,
  func,
  width,
  height,
  size,
  longPressEnabled,
  SFX,
  customClass,
  disableColor,
  transition,
  borderColor,
  textColor,
  background,
}: buttonProps) {
  const [anim, setanim] = useState(false)
  const [isClicked, setisClicked] = useState(false)
  const isMobile = isMobileDevice()

  // if (SFX) SFX.volume = audio.volume

  useEffect(() => {
    if (!longPressEnabled) {
      setTimeout(() => {
        setanim(false)
      }, 320)
    }
  }, [anim])

  const handleFunc = (b: boolean) => {
    setisClicked(b)
    setanim(b)
    func(b)
    if (b) {
      SFX.currentTime = 0
      SFX.play()
    }
  }
  return (
    <ButtonDiv
      data-testid='ButtonDiv'
      onTouchStart={() => isMobile && handleFunc(true)}
      onTouchEnd={() => isMobile && handleFunc(false)}
      onMouseDown={() => !isMobile && handleFunc(true)}
      onMouseUp={() => !isMobile && handleFunc(false)}
      onMouseLeave={() => !isMobile && isClicked && handleFunc(false)}
      width={width}
      height={height}
      size={size}
      anim={anim}
      borderColor={borderColor}
      background={background}
      textColor={textColor}
      className={customClass}
      disableColor={disableColor}
      transition={transition}
    >
      <div className='white' />
      {children}
    </ButtonDiv>
  )
}
